<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ACsVCl/tc-custom/9780811876469.jpg?1704761296851" alt="This image is the cover for the book Toddler Café"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Toddler Café
      </h1>
      <p class="bookDescription body article font2">
        <b>A creative guide to making mealtime fun instead of frustrating, with over fifty recipes! </b><b>“Finally . . . A cookbook that encourages kids to play with their food.” —<i>Times Union</i></b><br/>  <br/> Every toddler goes through a temporary phase when they want nothing but “O”-shaped cereal. But the real challenge for parents is getting kids to ask for fruit salad instead of cupcakes.<br/>  <br/> Faced with this seemingly impossible task with her own child, Jennifer Carden has created <i>The Toddler Café</i>, a guide to making mealtime with children fun and interactive. It offers simple, creative ways for kids to look at their food differently—like saying tuna salad is what mermaids eat—or making Minty Pea Pops in ice cube trays. Carden has created over fifty unique recipes that encourage families (including toddlers) to work together to prepare, eat, clean up, and best of all, look forward to a healthy, delicious meal.<br/>  <br/> “Full of great ideas to have fun with children at the table.” —<i>Super Chef Blog</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennifer Carden, Matthew Carden
      </h2>
      
      <p class="authorDescription body article">Jennifer Carden is an artist, chef, food stylist, and mother in the San Francisco Bay Area. She contributed to <I>The Healthy Baby Workbook</I>.<br/><br/>Matthew Carden is a photographer in the San Francisco Bay Area.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?699acbf5